export default __webpack_public_path__ + "static/fb_icon-ea614003805aaaa76c30c6fb732d4699.png";